import dayjs from 'dayjs'

export function containsLetters(str?: string) {
  return str && /^[A-Za-z]+$/.test(str)
}

export const generateTimeOptions = (step = 10) => {
  const options = []

  // eslint-disable-next-line no-plusplus
  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += step) {
      const formattedHour = hour.toString().padStart(2, '0')
      const formattedMinute = minute.toString().padStart(2, '0')
      options.push(`${formattedHour}:${formattedMinute}`)
    }
  }

  return options?.map((item) => ({ value: item, label: item })).reverse()
}

export const getTimeDifference = (valueStart: string, valueEnd: string) => {
  return (
    valueStart &&
    valueEnd &&
    dayjs(getDateForTimeDiff(valueEnd)).diff(
      getDateForTimeDiff(valueStart),
      'minutes'
    )
  )
}

export const convertMinutes = (durationInMinutes: number) => {
  const hours = Math.floor(durationInMinutes / 60) // Get the integer value of hours
  const minutes = durationInMinutes % 60 // Get the remaining minutes
  return { hours, minutes }
}

export const getisValidTime = (value: string) =>
  value !== '' && value?.length === 5

export const getDateForTimeDiff = (value?: string | dayjs.Dayjs) => {
  const todayDate = dayjs().format('YYYY-MM-DD')

  return `${todayDate}T${value}:00.000Z`
}

export const getRequiredRule = (fieldName: string) => {
  return {
    required: true,
    message: `The ${fieldName} field is required`,
  }
}
